import { reactive } from 'vue';
import axios from 'axios';
import { globalState } from '../globalState.js';

export const voiceOptions = reactive([]);
export let defaultVoiceId = '';
export let defaultVoiceOption = null;

let isLoaded = false;
let loadPromise = null;

function normalizeVoiceEntry(entryParam) {
  const entry = entryParam !== null && entryParam !== undefined && typeof entryParam === 'object' ? entryParam : {};
  return {
    voiceId: typeof entry.voiceId === 'string' ? entry.voiceId : '',
    providerId: typeof entry.providerId === 'string' ? entry.providerId : '',
    providerLabel: typeof entry.providerLabel === 'string' ? entry.providerLabel : '',
    runtimeType: typeof entry.runtimeType === 'string' ? entry.runtimeType : '',
    engineVersion: typeof entry.engineVersion === 'string' ? entry.engineVersion : '',
    displayName: typeof entry.displayName === 'string' ? entry.displayName : '',
    voiceName: typeof entry.voiceName === 'string' ? entry.voiceName : '',
    language: typeof entry.language === 'string' ? entry.language : '',
    languages: Array.isArray(entry.languages) === true ? entry.languages.filter((item) => typeof item === 'string') : [],
    accent: typeof entry.accent === 'string' ? entry.accent : '',
    accentOptions: Array.isArray(entry.accentOptions) === true ? entry.accentOptions.filter((item) => typeof item === 'string') : [],
    promptToVoiceSupported: entry.promptToVoiceSupported === true,
    supportFeatures: Array.isArray(entry.supportFeatures) === true ? entry.supportFeatures.filter((item) => typeof item === 'string') : [],
    description: typeof entry.description === 'string' ? entry.description : '',
    catalogDescription: typeof entry.catalogDescription === 'string' ? entry.catalogDescription : '',
    tierLabel: typeof entry.tierLabel === 'string' ? entry.tierLabel : '',
    gender: typeof entry.gender === 'string' ? entry.gender : '',
    hidden: entry.hidden === true
  };
}

export async function fetchVoices() {
  if (isLoaded) return voiceOptions;
  if (loadPromise) return loadPromise;
  
  loadPromise = (async () => {
    try {
      const res = await axios.get(`${globalState.apiEndpoint}/api/config/voices`);
      const rawVoices = Array.isArray(res.data) === true ? res.data : [];
      const normalizedVoices = rawVoices.map((entry) => normalizeVoiceEntry(entry)).filter((entry) => entry.voiceId !== '');
      voiceOptions.splice(0, voiceOptions.length, ...normalizedVoices);
      if (voiceOptions.length > 0) {
        defaultVoiceOption = voiceOptions[0];
        defaultVoiceId = voiceOptions[0].voiceId;
      }
      isLoaded = true;
      return voiceOptions;
    } catch (e) {
      console.error('Failed to load voices', e);
      return [];
    }
  })();
  
  return loadPromise;
}

export function getVoiceOptionById(voiceIdParam) {
  const voiceId = typeof voiceIdParam === 'string' ? voiceIdParam.trim() : '';
  if (voiceId === '') {
    return defaultVoiceOption;
  }
  const found = voiceOptions.find((entry) => entry.voiceId === voiceId);
  if (found !== undefined && found !== null) {
    return found;
  }
  return defaultVoiceOption;
}


